module.exports = __webpack_public_path__ + "static/media/NashvilleRealProducersMag.436b35f6.pdf";